import store from '@/store'
import { api } from '@/config'
export async function saveCasualUser(casualUser) {
  try {
    store.commit('SET_PROCESSING', true)
    const loggedUser = store.getters.loggedUser
    let isChanged = false

    //for edit
    const casualsArray = (loggedUser.casualUsers || []).map(casual => {
      if (casualUser.email === casual.email) {
        isChanged = true
        return {
          email: casualUser.email,
          name: casualUser.name,
          phoneNumber: casualUser.phoneNumber,
          organizationId: loggedUser.organizationId,
        }
      } else return casual
    })

    //for add
    if (!isChanged) {
      casualsArray.push({
        email: casualUser.email,
        name: casualUser.name,
        phoneNumber: casualUser.phoneNumber,
        organizationId: loggedUser.organizationId,
      })
    }

    const res = await api.put(`casuals/${loggedUser.userId}/update-casuals`, {
      casuals: casualsArray,
      groups: loggedUser.casualGroups,
    })

    if (res.status !== 200) throw new Error('Error updating casuals')
    loggedUser.casualUsers = res.data.casuals
    loggedUser.casualGroups = res.data.groups
  } catch (e) {
    console.log(e)
  } finally {
    store.commit('SET_PROCESSING', false)
  }
}
